export default __webpack_public_path__ + "static/media/shareplug.f052a30b.mp4";